import { connect } from 'react-redux';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { BAGGAGE_SERVICE } from '../../products';
import MainBaggageService from './MainBaggageService';
import SmallBaggageService from './SmallBaggageService';
import { jsx as _jsx } from "react/jsx-runtime";
const BaggageService = props => {
  switch (props.layoutType) {
    case ProductCardLayoutType.Small:
      return /*#__PURE__*/_jsx(SmallBaggageService, {
        ...props
      });
    case ProductCardLayoutType.Main:
    default:
      return /*#__PURE__*/_jsx(MainBaggageService, {
        ...props
      });
  }
};
const mapStateToProps = (state, _ref) => {
  let {
    form
  } = _ref;
  return {
    isSelected: getSelected(BAGGAGE_SERVICE.name, form)(state)
  };
};
export default connect(mapStateToProps)(BaggageService);